import React from 'react';
import { useAuth } from '../context/AuthContext';
import Settings from './Settings';
import PlatformSettings from './PlatformSettings';

/** Super admin sees platform credit defaults; hostel admin sees property settings. */
const SettingsRouter: React.FC = () => {
  const { isSuperAdmin } = useAuth();
  return isSuperAdmin() ? <PlatformSettings /> : <Settings />;
};

export default SettingsRouter;
